import React from 'react';
import InformationPage from './InformationPage/index'
import DashboardLayout from './layout/dashboardLayout';

const InformationUpdatePage = (props) => {
    return (
        <DashboardLayout>
            <InformationPage />
        </DashboardLayout>
    )
};
export default InformationUpdatePage;